module.exports = __webpack_public_path__ + "static/media/19.cf7c2564.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/19.jpg
// module id = 87
// module chunks = 0